export default __webpack_public_path__ + "static/media/yellow-4.1bd430d5.svg";